
export const API_ROUTES = {
  AGENT: '/api/agent',
  PROFILE: '/api/profile',
  AGENT_KNOWLEDGE: '/api/agent/knowledge',
  SUBSCRIPTION: '/api/subscription',
  SUBSCRIPTION_TOPUP: '/api/subscription/topup',
  STRIPE_CHECKOUT: '/api/stripe/checkout',
  STREAKS: '/api/streaks',
  XP: '/api/xp',
  STREAKS_VERIFY: '/api/streaks/verify',
}

export const PAGE_ROUTES = {
  HOME: '/',
  AGENT: '/agent',
  PROFILE: '/profile',
  CHECKOUT: '/checkout',
  RETURN: '/return',
  PRICING: '/pricing',

  AUTH_PASSWORD_RESET: '/auth/password-reset',
  AUTH_RESEND_VERIFICATION_EMAIL: '/auth/resend-verification-email',
  AUTH_SIGNIN: '/auth/signin',
  AUTH_SIGNUP: '/auth/signup',
  AUTH_UPDATE_PASSWORD: '/auth/update-password',
}
